import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchDeskList = createAsyncThunk("fetchDeskList", async () => {
	const response = await axiosHttp.get(`desk/list?page=1&limit=10000000`);
	return response.data.data;
});

const DeskListSlice = createSlice({
	name: "DeskListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchDeskList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchDeskList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.currentPage;
			state.total = action.payload.total;
		});
		builder.addCase(fetchDeskList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default DeskListSlice.reducer;
